// extracted by mini-css-extract-plugin
export default {"contentLayout":"ContentLayout_contentLayout__INWnS","contentLayout_paddingY_large":"ContentLayout_contentLayout_paddingY_large__ZhyG2"};